import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import { cookiePrivacyPolicyPopupStyles } from "@insite/content-library/Components/CookiePrivacyPolicyPopup";
import getColor from "@insite/mobius/utilities/getColor";

import { css } from "styled-components";

cookiePrivacyPolicyPopupStyles.drawer = mergeToNew(cookiePrivacyPolicyPopupStyles.drawer, {
    cssOverrides: {
        drawerContent: css`
            padding: 15px;
            margin: 0 auto;
            width: 100%;
            background: ${getColor("secondary")};
        `,
        drawerContainer: css`
            background: ${getColor("secondary")};
        `,
        drawerBody: css`
            display: flex;
            justify-content: center;
            background: ${getColor("secondary")};
        `,
    },
});

cookiePrivacyPolicyPopupStyles.container = mergeToNew(cookiePrivacyPolicyPopupStyles.container, {
    css: css`
        margin: 0 auto;
        background: ${getColor("secondary")};
    `,
});

cookiePrivacyPolicyPopupStyles.messageGridItem = mergeToNew(cookiePrivacyPolicyPopupStyles.messageGridItem, {
    css: css`
        align-items: center;
    `,
});
